// TODO 暂时先用base-libs，后续使用新的包
import { elk, acc, util } from '@tencent/ppd-base-libs';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

/** 登录态失效错误标示 **/
const SESSION_OUT_ERROR = 'session_out_error';
const CACHE_REPROT_KEY = '_$$_session_out_report_data';

/**
 * 获取GGI响应的ELK上报数据
 * @param res
 * @param startTime
 * @returns
 */
function getCGIReportElkData(res: AxiosResponse, startTime?: number) {
  const { config, data = {} } = res;
  const { url = '' } = config;
  const urlMatch = url.match(/\/?([\w-]*\.f?cgi)[^-]*/);
  const cgiName = urlMatch ? urlMatch[1] : 'ajax';
  const { retcode } = data;
  const reqObj = util.paramsToObject(config.data);

  // 过滤掉密码参数，太长了
  if (reqObj.pay_pwd) {
    // 干掉pay_pwd
    reqObj.pay_pwd = '*';
  }
  if (reqObj.pin) {
    // 干掉pin
    reqObj.pin = '*';
  }
  if (reqObj.pwd) {
    // 干掉pwd
    reqObj.pwd = '*';
  }
  return {
    errCode: retcode,
    msg: data,
    method: config.method,
    url: config.url,
    body: reqObj,
    key: cgiName,
    timeDiff: startTime ? new Date().getTime() - startTime : 0,
    str1: data.retmsg || '',
    str2: 'ajax',
    str4: config.params, // str3是关键字 所以用4
  };
}

/**
 * 获取GGI响应的ELK上报数据
 * @param res
 * @param startTime
 * @returns
 */
function getCGIReportAccData(res: AxiosResponse, startTime?: number) {
  const cost = startTime ? new Date().getTime() - startTime : 0;
  const { config, data = {} } = res;
  const { url = '' } = config;
  const urlMatch = url.match(/\/?([\w-]*\.f?cgi)[^-]*/);
  const cgiName = urlMatch ? urlMatch[1] : 'ajax';
  const { retcode } = data;
  return {
    /* service */
    service: cgiName,
    /* 请求耗时  微秒 */
    cost: cost * 1000,
    /* 错误码 */
    retcode,
  };
}

/**
* 解析数据
* @param response
* @returns
*/
function resolveCGIReportData(response: AxiosResponse, isSessionOut = false) {
  const reportElkData = getCGIReportElkData(response);
  if (isSessionOut) {
    Object.assign(reportElkData, { str3: SESSION_OUT_ERROR });
  }
  const reportAccData = getCGIReportAccData(response);
  return {
    elkData: reportElkData,
    accData: reportAccData,
  };
}

/**
 * 上报CGI数据
 * @param response
 */
export function reportCGIData(response: AxiosResponse, isSessionOut = false) {
  try {
    const data = resolveCGIReportData(response, isSessionOut);
    // 先存储上报数据，防止页面刷新导致数据上报失败
    sessionStorage.setItem(CACHE_REPROT_KEY, JSON.stringify(data));
    const { elkData, accData } = data;
    // 先直接上报
    elk(elkData);
    acc(accData);
    // 如果页面没有跳走，1.5s后应该能上报完毕，这里删除
    setTimeout(() => {
      sessionStorage.removeItem(CACHE_REPROT_KEY);
    }, 1500);
  } catch (error) {

  }
}

/**
 * 上报上次缓存的数据
 */
export function reportCacheCGIData() {
  try {
    const data = sessionStorage.getItem(CACHE_REPROT_KEY);
    if (data) {
      const { elkData, accData } = JSON.parse(data);
      elkData && elk(elkData);
      accData && acc(accData);
      sessionStorage.removeItem(CACHE_REPROT_KEY);
    }
  } catch (error) {

  }
}

/**
 * 上报被拦截的请求url
 * @param config
 */
export function reportUrlData(config: AxiosRequestConfig) {
  const { url = '' } = config;
  setTimeout(() => {
    elk({
      key: SESSION_OUT_ERROR,
      msg: url,
    });
  });
}

